(() => {
  'use strict';

  function setupBildhauerbeitel() {
    const schnitzenDetails = document.querySelector(
      '#Details-menu-drawer-produkte-schnitzen'
    );

    if (!schnitzenDetails) return;

    const menuList = schnitzenDetails.querySelector(
      ':scope > ul.menu-drawer__menu--grandchildlist'
    );

    if (!menuList || menuList.dataset.bildhauerbeitelReady === 'true') {
      return;
    }

    const items = Array.from(menuList.children).filter((item) =>
      item.matches(':scope > li')
    );

    const bildhauerItem = items.find((item) => {
      const text = item
        .querySelector('.menu-drawer__menu-item-text')
        ?.textContent
        .trim();

      return text === 'Bildhauerbeitel';
    });

    const stichItems = items.filter((item) => {
      const text = item
        .querySelector('.menu-drawer__menu-item-text')
        ?.textContent
        .trim();

      return text && text.startsWith('Stich');
    });

    if (!bildhauerItem || stichItems.length === 0) return;

    const wrapper = document.createElement('li');
    wrapper.className =
      'menu-drawer__list-item menu-drawer__list-item--deep menu-drawer__special-bildhauerbeitel';

    const details = document.createElement('details');
    details.className = 'custom-bildhauerbeitel-details';

    const summary = document.createElement('summary');
    summary.className =
      'menu-drawer__menu-item menu-drawer__menu-item--parent focus-inset';

    const title = document.createElement('span');
    title.className = 'menu-drawer__menu-item-text wrap-text';
    title.textContent = 'Bildhauerbeitel';

    const chevron = document.createElement('span');
    chevron.className = 'custom-bildhauerbeitel-chevron';
    chevron.setAttribute('aria-hidden', 'true');

    summary.append(title, chevron);

    const submenu = document.createElement('ul');
    submenu.className =
      'menu-drawer__menu menu-drawer__menu--grandchildlist details-content';
    submenu.setAttribute('role', 'list');
    submenu.tabIndex = -1;

    stichItems.forEach((item) => {
      submenu.appendChild(item);
    });

    details.append(summary, submenu);
    wrapper.appendChild(details);

    bildhauerItem.replaceWith(wrapper);
    menuList.dataset.bildhauerbeitelReady = 'true';
  }

  document.addEventListener('DOMContentLoaded', setupBildhauerbeitel);

  const observer = new MutationObserver(() => {
    setupBildhauerbeitel();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();